module.exports = __webpack_public_path__ + "img/case2.63d40606.png";